import styled from '@emotion/styled/macro';
import { getSportColour } from '../../sports/sportColours';

export const CardCell = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 450px;

    @media (max-width: ${props => props.theme.widths.tabletMax}) {
        max-width: 430px;
    }

    @media (max-width: ${props => props.theme.widths.mobileMax}) {
        max-width: 100%;
    }
`;

export const Card = styled.div`
    background: ${props => props.theme.colours.textWhite};
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    width: 100%;
    flex: 1;
    filter: ${props =>
        props.label === 'Abandoned' ? 'grayscale(100%)' : 'none'};
    opacity: ${props => (props.label === 'Abandoned' ? 0.6 : 1)};
    pointer-events: ${props => (props.label === 'Abandoned' ? 'none' : 'auto')};

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    }
`;

export const CardBackground = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px 16px;
    width: 100%;
    box-sizing: border-box;
    height: 127px;
    background: ${props => {
        const colour = getSportColour(props.sport);
        return props.backgroundUrl
            ? `url(${props.backgroundUrl}) center -34px/cover no-repeat, ${colour}`
            : colour;
    }};

    @media (max-width: ${props => props.theme.widths.tabletMax}) {
        height: 122px;
    }

    @media (max-width: ${props => props.theme.widths.mobileMax}) {
        height: 122px;
        padding: 10px 12px;
        background-position: center center;
    }
`;

export const PrizeAsset = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 0;

    img {
        height: 80%;
        width: auto;
        max-width: 72%;
        object-fit: contain;
    }
`;

export const SportIcon = styled.span`
    position: relative;
    z-index: 1;
    width: 25px;
    height: 25px;
    flex: 0 0 auto;
    border-radius: 50%;
    background: ${props => props.theme.colours.textWhite};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    box-sizing: border-box;

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const StatusBadge = styled.span`
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.normal};
    font-weight: 700;
    color: ${props => props.theme.colours.textGreen};
    background: white;
    padding: 4px 12px;
    border-radius: 9999px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const CardBodyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 334px;
    flex: 1;
    gap: 8px;
    padding: 12px;
    box-sizing: border-box;
`;

export const CountdownWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 4px;
    border-radius: 8px;
    box-shadow: 0px 0px 6px 1px #28282826;
    padding: 8px;
    box-sizing: border-box;
    overflow: hidden;
`;

export const SweepName = styled.h2`
    margin: 0;
    width: 100%;
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.large};
    line-height: 24px;
    color: ${props => props.theme.colours.textCardGreen};
    text-align: center;
    text-transform: uppercase;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const SelectionWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CardFooter = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: auto;
`;

export const AbandonedMessage = styled.p`
    width: 100%;
    max-width: 310px;
    height: 44px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.xsmall};
    color: ${props => props.theme.colours.textGray};
    text-align: center;
    line-height: 1.4;
`;

export const CtaButton = styled.button`
    width: 100%;
    height: 44px;
    border: none;
    border-radius: 12px;
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.medium};
    color: #ffffff;
    background: ${props => props.theme.colours.background.green};
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: opacity 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    &:hover {
        opacity: 0.9;
    }
`;

export const Terms = styled.p`
    width: 100%;
    margin: 8px 0 0 0;
    min-height: 32px;
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.normal};
    font-weight: 400;
    line-height: 16px;
    color: ${props => props.theme.colours.textDark};
    text-align: center;

    @media (max-width: ${props => props.theme.widths.mobileMax}) {
        font-size: ${props => props.theme.fontSize.xsmall};
    }
`;

export const TermsLink = styled.span`
    text-decoration: underline;
    cursor: pointer;
    color: ${props => props.theme.colours.textDark};
`;
